import { useState } from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
  IonSlides,
  IonSlide,
  IonSkeletonText,
  IonFab,
  IonFabButton,
  IonIcon,
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react';
import { observer } from 'mobx-react-lite';
import ReactPlayer from 'react-player';
import { volumeMute } from 'ionicons/icons';

import { getUrlFromPath } from 'libs/helpers/helper.lib';
import videoFeedStore from 'stores/video-feed.store';

import classes from './style.module.scss';

const StoryPage = ({ match, history }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [swiper, setSwiper] = useState();
  const [muteState, setMuteState] = useState(true);
  const videoFeeds = videoFeedStore.getObjects();
  const isLoading = videoFeedStore.getIsLoading();

  useIonViewDidEnter(() => {
    try {
      videoFeedStore.setFields(`
        id
        video_path
        video_cover
      `);
      videoFeedStore.searchObjects();
    } catch (error) {
      console.log(error);
    }
  });

  useIonViewWillLeave(() => {
    swiper?.destroy();
    videoFeedStore.resetAllFields();
  }, [swiper]);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <IonTitle>Stories</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent
        onClick={() => {
          setMuteState((prevState) => !prevState);
        }}
      >
        {videoFeeds.length > 0 && !isLoading ? (
          <>
            <IonSlides
              className={classes.ionSlides}
              pager={true}
              onIonSlidesDidLoad={async (e) => {
                const swiperLocal = await e.currentTarget.getSwiper();
                const query = new URLSearchParams(history.location.search);
                if (query.has('slide')) {
                  const slideToIndex = query.get('slide');
                  swiperLocal.slideTo(slideToIndex);
                }
                setSwiper(swiperLocal);
              }}
              onIonSlideDidChange={async (e) => {
                const activeIndex = await e.currentTarget.getActiveIndex();
                setActiveIndex(activeIndex);
              }}
            >
              {videoFeeds.map((videoFeed, index) => (
                <IonSlide key={videoFeed.id} className={classes.ionSlide}>
                  <div className={classes.videoOverlay}></div>
                  <ReactPlayer
                    url={getUrlFromPath(videoFeed.video_path)}
                    width='100%'
                    height='100%'
                    playing={activeIndex === index}
                    volume={muteState ? 0 : 1}
                    muted={muteState}
                    controls={false}
                    stopOnUnmount={true}
                    playsinline={true}
                    onEnded={() => {
                      swiper.slideNext();
                    }}
                    config={{
                      youtube: {
                        playerVars: {
                          showinfo: 0,
                          modestbranding: 1,
                          rel: 0
                        }
                      }
                    }}
                  />
                </IonSlide>
              ))}
            </IonSlides>
            {muteState && (
              <IonFab horizontal='end' slot='fixed' className={classes.ionFab}>
                <IonFabButton color='light'>
                  <IonIcon icon={volumeMute} />
                </IonFabButton>
              </IonFab>
            )}
          </>
        ) : (
          <div className={classes.skelton}>
            <IonSkeletonText
              animated
              style={{ width: '100%' }}
            ></IonSkeletonText>
          </div>
        )}
      </IonContent>
    </IonPage>
  );
};

export default observer(StoryPage);
